export default {
  pageTitle: 'Manage Vouchers',
  region: 'Region',
  statusFiltering: 'Status filtering',
  radio1: 'All',
  radio2: 'Pending/issue',
  radio3: 'Collected and unused',
  radio4: 'Used',
  radio5: 'Expired',
  timeFiltering: 'Time filtering',
  placeholder1: 'SO#',
  placeholder2: 'SO Serial',
  placeholder3: 'Voucher Code',
  placeholder4: 'User#',
  placeholder5: 'Phone',
  sure: 'Are you sure you want to disable it?',
  timeType1: 'Created time',
  timeType2: 'Collect or issue time',
  timeType3: 'Expire time',
  columns1: 'ID',
  columns2: 'Code',
  columns3: 'Template name',
  columns4: 'Voucher Batch ID',
  columns5: 'Created time',
  columns6: 'Condition',
  columns7: 'Denomination',
  columns8: 'Limit',
  columns9: 'Collect or issue time',
  columns10: 'Use time', // 原文里一开始就是两个user time
  columns11: 'Use time',
  columns12: 'Expire Time',
  columns13: 'LimitType',
  columns14: 'Owner Type',
  columns15: 'Status',
  columns16: 'Login ID',
  columns17: 'User name',
  columns18: 'Disable',
  // --------------------------
  ownerType1: 'Platform',
  ownerType2: 'Store',
  status1: 'Awaiting',
  status2: 'Unused',
  status3: 'Used',
  status4: 'Expired',
  status5: 'Invalidated',
  buttonValue1: 'Deactivate'
}
